'use strict';

function getFirstItem(array) {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    return array != null && array.length ? array[0] : undefined;
}
function getLastItem(array) {
    const length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
function getPrevItem(index, array, loop = true) {
    const prevIndex = getPrevIndex(index, array.length, loop);
    return array[prevIndex];
}
function getNextItem(index, array, loop = true) {
    const nextIndex = getNextIndex(index, array.length, 1, loop);
    return array[nextIndex];
}
function findIndex(array, item) {
    return array.indexOf(item);
}
function removeIndex(array, index) {
    return array.filter((_, idx) => idx !== index);
}
function addItem(array, item) {
    return [...array, item];
}
function removeItem(array, item) {
    return array.filter((eachItem) => eachItem !== item);
}
/**
 * Get the next index based on the current index and step.
 *
 * @param currentIndex the current index
 * @param length the total length or count of items
 * @param step the number of steps
 * @param loop whether to circle back once `currentIndex` is at the start/end
 */
function getNextIndex(currentIndex, length, step = 1, loop = true) {
    const lastIndex = length - 1;
    if (currentIndex === -1) {
        return step > 0 ? 0 : lastIndex;
    }
    const nextIndex = currentIndex + step;
    if (nextIndex < 0) {
        return loop ? lastIndex : 0;
    }
    if (nextIndex >= length) {
        if (loop)
            return 0;
        return currentIndex > length ? length : currentIndex;
    }
    return nextIndex;
}
/**
 * Get's the previous index based on the current index.
 * Mostly used for keyboard navigation.
 *
 * @param currentIndex - the current index
 * @param count - the length or total count of items in the array
 * @param loop - whether we should circle back to the
 * first/last once `currentIndex` is at the start/end
 */
function getPrevIndex(currentIndex, count, loop = true) {
    return getNextIndex(currentIndex, count, -1, loop);
}

exports.addItem = addItem;
exports.findIndex = findIndex;
exports.getFirstItem = getFirstItem;
exports.getLastItem = getLastItem;
exports.getNextIndex = getNextIndex;
exports.getNextItem = getNextItem;
exports.getPrevIndex = getPrevIndex;
exports.getPrevItem = getPrevItem;
exports.removeIndex = removeIndex;
exports.removeItem = removeItem;
//# sourceMappingURL=array.js.map
